import { render, staticRenderFns } from "./DeviceDiskonek.vue?vue&type=template&id=1b5b4aa0&"
import script from "./DeviceDiskonek.vue?vue&type=script&lang=js&"
export * from "./DeviceDiskonek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports